import * as moment from 'moment/moment';

export class EventType {
  constructor() {
    this.id = null;
    this.name = null;
    (this.code = null), (this.description = null);
    this.color = 'blue';
    this.icon = null;
    this.readonly = 'Yes';
    this.is_holiday = 'Yes';
  }
}
